import { Array } from '@common/Array/Array'

import type { TOs } from '../definitions'
import { APPLE_OSS } from '../definitions'

/**
 * Ez egy Apple eszköz?
 * @param os - Os típusa.
 */
export default function isApple (os: TOs): boolean {
  return Array.includes(APPLE_OSS, os)
}
